import { useEffect, useState } from "react";
import { useDevice } from "../../../common/hooks/useDevice";
import styled from "styled-components";
import { DashboardTicketProgressCard } from "./DashboardTicketProgressCard";
import { SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomTextCard from "../../../common/components/card/CustomTextCard";
import { DashboardRankCard } from "./DashboardRankCard";
import { useWindowSize } from "../../../common/hooks/useWindowSize";
import Translate from "../../../common/translate/Translate";
import TicketService from "../../../service/TicketService";
import RevenueService from "../../../service/RevenueService";
import { format, subDays } from "date-fns";

const TabletBottomGrid = styled.div`
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 17px;
    height: 357px;
`;

const BottomTextCardGrid = styled.div`
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    gap: 17px;
    height: 349px;
`;

const WebBottomGrid = styled.div`
    display: grid;
    grid-template-columns: calc(50% - 8px) 0.8fr 1.2fr;
    gap: 17px;
    height: 349px;
`;

function DashboardBottomArea() {
    const { width } = useWindowSize();
    const currentDevice = useDevice();
    const ticketService = new TicketService();
    const revenueService = new RevenueService();

    const [ticketStatus, setTicketStatus] = useState({
        totalTicket: 0,
        completeTicket: 0,
        refund: 0,
        equipment: 0,
        machine: 0,
        repair: 0,
        symptoms: 0,
    });

    const [revenueTotal, setRevenueTotal] = useState({
        dailyAverage: 0,
        monthly: 0,
    });

    const fetchTicketStatus = () => {
        ticketService
            .getTicketStatus()
            .then((result) => {
                setTicketStatus(result);
            })
            .catch((error) => {
                console.error("Error fetching ticket status:", error);
            });
    };

    const fetchRevenueTotal = () => {
        const endDate = format(new Date(), "yyyy-MM-dd");
        const startDate = format(subDays(new Date(), 30), "yyyy-MM-dd");
        revenueService
            .getRevenueTotal({ startDate, endDate })
            .then((result) => {
                setRevenueTotal(result);
            })
            .catch((error) => {
                console.error("Error fetching revenue total:", error);
            });
    };

    useEffect(() => {
        fetchTicketStatus();
        fetchRevenueTotal();
    }, []);

    const ticketProgressCard = (
        <DashboardTicketProgressCard
            totalCount={ticketStatus.totalTicket}
            completeCount={ticketStatus.completeTicket}
            refundCount={ticketStatus.refund}
            equipmentCount={ticketStatus.equipment}
            machineCount={ticketStatus.machine}
            repairCount={ticketStatus.repair}
            symptomCount={ticketStatus.symptoms}
        />
    );

    const dailyAverageCard = (
        <CustomTextCard
            title={Translate("dashboard.dailyRevenueAverage")}
            mainContent={`฿${revenueTotal.dailyAverage?.toLocaleString() ?? "0"}`}
            percentage={10.5}
            leftBottomText={Translate("common.lastMonth")}
        />
    );

    const monthlyCard = (
        <CustomTextCard
            title={Translate("dashboard.monthlyRevenue")}
            mainContent={`฿${revenueTotal.monthly?.toLocaleString() ?? "0"}`}
            percentage={-10.5}
            leftBottomText={Translate("common.lastMonth")}
        />
    );

    const rankCard = <DashboardRankCard />;

    if (currentDevice === "mobile") {
        return (
            <>
                {ticketProgressCard}
                <SizedBox height={"16px"} />
                {dailyAverageCard}
                <SizedBox height={"16px"} />
                {monthlyCard}
                <SizedBox height={"16px"} />
                {rankCard}
            </>
        );
    } else if (width <= 1500) {
        return (
            <>
                {ticketProgressCard}
                <SizedBox height={"16px"} />
                <TabletBottomGrid>
                    <BottomTextCardGrid>
                        {dailyAverageCard}
                        {monthlyCard}
                    </BottomTextCardGrid>
                    {rankCard}
                </TabletBottomGrid>
            </>
        );
    } else {
        return (
            <WebBottomGrid>
                {ticketProgressCard}
                <BottomTextCardGrid>
                    {dailyAverageCard}
                    {monthlyCard}
                </BottomTextCardGrid>
                {rankCard}
            </WebBottomGrid>
        );
    }
}

export default DashboardBottomArea;
